<template>
    <UiFaqs :blok="blok" :with-arrows="true" class="apr-faq-section" />
</template>

<script setup lang="ts">
import type { IFaqSection } from '@nuxt-monorepo/ui/types/components/Faqs';

const { blok } = defineProps<{ blok: IFaqSection }>();
</script>

<style lang="postcss" scoped>
.apr-faq-section {
    @apply px-0 apr-section;
    :deep(.container) {
        @apply flex flex-col md:gap-12 px-4 xl:px-0 md:flex-row;

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            @apply text-text-primary-asphalt text-left mb-6 lg:mb-4 md:leading-[3.25rem] md:mb-0 shrink-0;

            &.simple-text-title {
                @apply text-xl md:text-5xl uppercase font-bold md:w-[368px];
            }
        }

        .subtitle {
            @apply hidden;
        }

        .accordions {
            @apply border-b-[#e3e4e4] border-b border-solid flex-grow;
        }

        .accordion {
            @apply border-t-neutral-light-grey border-t border-solid px-0 pt-4 pb-0;
            .accordion-icon .iconify {
                @apply transition-transform;
            }
            &.active {
                .accordion-icon .iconify {
                    @apply rotate-180;
                }
                .accordion-header {
                    /* @apply text-[#25a0de]; */
                }
            }

            .accordion-header {
                @apply text-text-primary-asphalt text-base font-semibold pb-4;
            }
        }

        .accordion-title {
            @apply text-base font-semibold;
        }

        .accordion-body {
            @apply text-base font-normal pt-0;
            a {
                @apply text-link;
            }
        }
    }
}

.faq-accordion {
    &:has(+ .breadcrumbs) {
        @apply !pb-12;
    }
}
</style>
